import { useState, useMemo } from "react";
import styles from "../NextLevelFeatures/NextLevelFeatures.module.css";
import TitleBar from "../../TitleBar/TitleBar";

const NextLevelFeatures = (props) => {
  const hf = props?.HomeFeature?.HomeFeature ?? props?.HomeFeature ?? {};
  const dataItems = hf.dataItems || [];
  const featureItems = hf.featureItems || [];
  const subtitleBlocks = hf.subtitle;

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [active, setActive] = useState(null);

  const toCard = (it, id) =>
    it && {
      id,
      title: it.title,
      desc: it.desc ?? it.description ?? "",
      icon: it.icon?.src || "",
      gradient: it.gradient,
      borderColor: it.borderColor || "#EDEDED",
    };
  const { data1, data2, data3 } = useMemo(() => {
    const r1 = dataItems
      .slice(0, 3)
      .map((it, i) => toCard(it, i + 1))
      .filter(Boolean);
    const left = toCard(dataItems[3], 4);
    const special = {
      id: 5,
      title: "FEATURES",
    };
    const right = toCard(dataItems[4], 6);
    const r2 = [left, special, right].filter(Boolean);
    const r3 = dataItems
      .slice(5)
      .map((it, i) => toCard(it, 7 + i))
      .filter(Boolean);

    return { data1: r1, data2: r2, data3: r3 };
  }, [dataItems]);
  const features = useMemo(
    () =>
      featureItems.map((f, i) => ({
        id: i + 1,
        title: f.title,
        desc: f.desc ?? f.description ?? "",
        icon: f.icon?.src || "",
        btn: f.cta?.label || "Book a Demo",
        href: f.cta?.href || null,
        gradient: f.gradient,
        borderColor: f.borderColor || "#EDEDED",
      })),
    [featureItems]
  );

  const renderCard = (item) => {
    if (item.id === 5) {
      return (
        <div key={item.id} className={`${styles.card} ${styles.specialCard}`}>
          <h1 className={styles.specialTitle}>
            <span>F</span>
            <span>E</span>
            <span>A</span>
            <span>T</span>
            <span>U</span>
            <span>R</span>
            <span>E</span>
            <span>S</span>
          </h1>
        </div>
      );
    }
    const noHoverIds = [];
    const hasHover = !noHoverIds.includes(item.id);

    return (
      <div
        key={item.id}
        className={styles.card}
        style={{
          backgroundImage: item.gradient,
          border: `2px solid ${item.borderColor}`,
        }}
        onMouseEnter={() => hasHover && setHoveredIndex(item.id)}
        onMouseLeave={() => hasHover && setHoveredIndex(null)}
      >
        <h3 className={styles.title}>{item.title}</h3>
        <p
          className={`${styles.desc} ${
            hasHover && hoveredIndex === item.id ? styles.show : ""
          }`}
        >
          {item.desc}
        </p>
        <button
          className={`${styles.btn} ${
            hasHover && hoveredIndex === item.id ? styles.show : ""
          }`}
        >
          Book a Demo
        </button>
        <div
          className={`${styles.icon} ${
            hasHover && hoveredIndex === item.id ? styles.hide : ""
          }`}
        >
          {item.icon ? <img src={item.icon} alt={item.title} /> : null}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <TitleBar blocks={subtitleBlocks} />
        <div className={styles.GridSection}>
          <div className={styles.grid}>
            {data1.map((item) => renderCard(item))}
          </div>
          <div className={styles.gridSecond}>
            {data2.map((item) => renderCard(item))}
          </div>
          <div className={styles.gridFive}>
            {data3.map((item) => renderCard(item))}
          </div>
        </div>

        {/* Mobile layout (pairs) */}
        <div className={styles.mobGridSection}>
          <div className={styles.wrapper}>
            {features.map((item, index) => {
              if (index % 2 !== 0) return null;
              return (
                <div key={index} className={styles.pairContainer}>
                  {[item, features[index + 1]].map((card, i) => {
                    if (!card) return null;
                    const cardIndex = index + i;
                    const isActive = active === cardIndex;
                    const isInactive =
                      active !== null &&
                      active !== cardIndex &&
                      Math.floor(active / 2) === Math.floor(cardIndex / 2);

                    const onMobileCTA = () => {
                      if (card.href) window.location.href = card.href;
                    };

                    return (
                      <div
                        key={card.id}
                        className={`${styles.card2} ${
                          isActive ? styles.active : ""
                        } ${isInactive ? styles.inactive : ""}`}
                        style={{
                          background: card.gradient,
                          border: `2px solid ${card.borderColor}`,
                        }}
                        onMouseEnter={() => setActive(cardIndex)}
                        onMouseLeave={() => setActive(null)}
                      >
                        {!isInactive && (
                          <div
                            className={
                              isActive ? styles.titleRow : styles.titleRow2
                            }
                          >
                            <h3>{card.title}</h3>
                            {!isActive && card.icon && (
                              <img
                                src={card.icon}
                                alt="icon"
                                className={styles.cardIcon}
                              />
                            )}
                          </div>
                        )}
                        {!isInactive && (
                          <>
                            <p>{card.desc}</p>
                            <button onClick={onMobileCTA}>{card.btn}</button>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextLevelFeatures;
